import { render, staticRenderFns } from "./line3.vue?vue&type=template&id=1deda620&scoped=true&"
import script from "./line3.vue?vue&type=script&lang=js&"
export * from "./line3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deda620",
  null
  
)

export default component.exports